import { useState } from "react";
import { Outlet } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { Sidebar, NavList } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { Logo } from "@/components/layout/Logo";
import { AmbientMesh } from "@/components/layout/AmbientMesh";
import { CommandPalette } from "@/components/layout/CommandPalette";
import { GuidedTour } from "@/components/layout/GuidedTour";

export function AppShell() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="relative min-h-screen bg-background text-foreground" data-testid="app-shell">
      <AmbientMesh />
      <CommandPalette />
      <GuidedTour />

      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent
          side="left"
          className="w-72 border-r border-border/60 bg-[hsl(var(--surface-sidebar))] p-0"
          data-testid="mobile-sidebar"
        >
          <div className="flex h-16 items-center border-b border-border/60 px-5">
            <Logo />
          </div>
          <div className="py-4">
            <NavList onNavigate={() => setMobileOpen(false)} />
          </div>
        </SheetContent>
      </Sheet>

      <Topbar collapsed={collapsed} onOpenMobile={() => setMobileOpen(true)} />

      <main
        className={cn(
          "relative z-[1] pt-16 transition-[padding] duration-200",
          collapsed ? "lg:pl-[76px]" : "lg:pl-64"
        )}
      >
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
